import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/lib/locale/es";

Vue.use(Vuetify);

const theme = {};

export default new Vuetify({
  lang: {
    locales: { es },
    current: "es",
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
});
